import React from 'react';
import PropTypes from 'prop-types';

import backgroundSources, { BACKGROUND_SIZES } from 'Components/Banner/CarouselBackground/helpers/backgroundSources';
import { fixedSources } from 'Helpers/Image/image-urls';
import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';
import SkeletonImg, { FROM_MD, BELOW_MD } from 'Components/Skeleton/SkeletonImg';
import SkeletonStripBanner from 'Components/Skeleton/SkeletonStripBanner';

// The logo's FixedImg width in CarouselBackground
const LOGO_WIDTH = 340;

/**
 * The carousel background campaign around the home page's featured carousel (Components/Banner/CarouselBackground),
 * for page skeletons. Can show alongside the take over. Each part is only shown when the worker has its image
 * (`data-skeleton-if`): the mobile banner above the carousel below md, and from md up the heading (logo, strapline
 * and button) with the background image behind the carousel. Its strip banner, if it has one, goes above.
 * Slots: `carousel-background`, `carousel-background-mobile`, `carousel-background-logo` (image URLs), plus
 * SkeletonStripBanner's for `carousel-background-strip`.
 */
export default function SkeletonCarouselBackground({ children }) {
  return (
    <div className="SkeletonCarouselBackground">
      <div className="SkeletonCarouselBackground__top">
        <div className="SkeletonCarouselBackground__mobile" data-skeleton-if="carousel-background-mobile">
          <SkeletonImg slot="carousel-background-mobile" sizes="100vw" media={BELOW_MD} />
        </div>
        <SkeletonStripBanner slot="carousel-background-strip" />
      </div>

      <div className="SkeletonCarouselBackground__stage">
        <section className="container">
          <div className="SkeletonCarouselBackground__heading" data-skeleton-if="carousel-background">
            <div className="SkeletonCarouselBackground__headingContent">
              <div className="SkeletonCarouselBackground__logo">
                <SkeletonImg
                  slot="carousel-background-logo"
                  sizes={`${LOGO_WIDTH}px`}
                  sources={url => fixedSources(url, LOGO_WIDTH)}
                  media={FROM_MD}
                />
              </div>
              <SkeletonBlock className="SkeletonCarouselBackground__text" />
            </div>
            <SkeletonBlock className="SkeletonCarouselBackground__button" />
          </div>

          {children}
        </section>

        <div className="SkeletonCarouselBackground__background" data-skeleton-if="carousel-background">
          <SkeletonImg slot="carousel-background" sizes={BACKGROUND_SIZES} sources={backgroundSources} media={FROM_MD} />
        </div>
      </div>
    </div>
  );
}

SkeletonCarouselBackground.propTypes = {
  children: PropTypes.node.isRequired,
};
